import React, { useState, useEffect } from "react";
import UserService from "../services/user.service";
import EventBus from "../common/EventBus";
import { Table, Spinner, Button, Container, Modal, Form, ButtonGroup, Pagination, Alert, Col, Row  } from 'react-bootstrap';
import { FaEdit, FaTrash } from 'react-icons/fa';
import ErrorModal from './ErrorModal';

const BoardAreaGroup = () => {
  const [areaGroup, setAreaGroup] = useState([]);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedAreaGroup, setSelectedAreaGroup] = useState(null);
  const [deleteState, setDeleteState] = useState(false);
  const [apierrors, setApiErrors] = useState('');// Error state
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [filterTerm, setFilterTerm] = useState('');
  
  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState(' Lade, bitte warten...');
  const [showModal, setShowModal] = useState(false);
  const [errors, setErrors] = useState({}); // Error state
  const [errorCode, setApiErrorCode] = useState('');// Error state


  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(5); // Set items per page


  const [formData, setFormData] = useState({
    area_group_name: "",
    
  });

  const validateForm = () => {
    const newErrors = {};    
    if (!formData.area_group_name.trim()) {
      newErrors.area_group_name = 'Area Group Name Name is required';
    }  
    console.log(newErrors);
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };

  useEffect(() => {
    
    UserService.getAreaGroupBoard().then(
      (response) => {
        setAreaGroup(response.data);
       
      }).catch((error) => {
        console.log(error);
        console.log(error.message);
        const _content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
          console.log(_content);
          if (error.response) {
            // Server responded with a status other than 200 range
            setApiErrors(`Error: ${error.name} - ${error.response.data.message}-${error.code}`);
            setApiErrorCode(`Error: ${error.name} - ${error.code}`);
          } else if (error.request) {
            // Request was made, but no response was received
            setApiErrors('Error: No response received from the server.');
            setApiErrorCode(`Error: ${error.name} - ${error.code}`);
          } else {
            // Other types of errors
            setApiErrors(`Error: ${error.response.data.message}`);
            setApiErrorCode(`Error: ${error.name} - ${error.code}`);
          } 
        setAreaGroup(_content);

        if (error.response && error.response.status === 401) {
          EventBus.dispatch("logout");
        }
        
      
});
  }, [deleteState]);
  
 

// Filter the mainvos based on the filter input
const filteredMainVOs = Array.isArray(areaGroup)
    ? areaGroup.filter((vo) =>
        (vo.area_group_name && vo.area_group_name.toLowerCase().includes(filterTerm.toLowerCase())) ||
        (vo.rec_date && vo.rec_date.includes(filterTerm))
      )
    : [];

  
// Get the current page's data
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentMainVOs = filteredMainVOs.slice(indexOfFirstItem, indexOfLastItem);
 
   // Handle pagination
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Sorting function
  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };
  

  // Sort the filtered data
  const sortedMainVOs = [...filteredMainVOs].sort((a, b) => {
    if (a[sortConfig.key] < b[sortConfig.key]) {
      return sortConfig.direction === 'asc' ? -1 : 1;
    }
    if (a[sortConfig.key] > b[sortConfig.key]) {
      return sortConfig.direction === 'asc' ? 1 : -1;
    }
    return 0;
  });


  // Total pages calculation
  const totalPages = Math.ceil(filteredMainVOs.length / itemsPerPage);

  const handleEditClick = (main_vo) => {
    setApiErrors(null);
    setApiErrorCode(null);
    setSelectedAreaGroup(main_vo);
    setFormData(main_vo);
    setShowEditModal(true);
  };

  const handleCreateClick = () => {
    setApiErrors(null);
    setApiErrorCode(null);
    setFormData({
      area_group_name: "",
      
    });
    setShowCreateModal(true);
  };

  const isValidDate = (date) => {
    return !isNaN(Date.parse(date));
  };

  const handleDeleteClick = async (id,e) => {
    e.preventDefault();
    setApiErrors(null);
    setApiErrorCode(null);
    try {
      
      setLoadingText('Daten werden gelöscht, bitte warten...');
      setLoading(true);
      await UserService.deleteAreaGroupBoard(id);
      setDeleteState(prev => !prev);
      console.info(deleteState);
    } catch (error) {
      setApiErrors(`Error: ${error.name}-${error.code} - ${error.response.data.message}-${error.response.data.error}`);
      setApiErrorCode(`Error: ${error.name} - ${error.code}`);
      setShowModal(true);
      console.error('Error deleting Area Group:', error);
    }
    finally {
      setLoading(false);
    }
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    console.log(formData);
    console.log(selectedAreaGroup);
    if (!validateForm()) return; 
    try {
      setLoadingText('Daten werden aktualisiert, bitte warten...');
      setLoading(true);
      // formData.rec_date = new Date();
      await UserService.updateAreaGroupBoard(selectedAreaGroup.area_group_id,formData);
      setDeleteState(prev => !prev);
      setShowEditModal(false);
    } catch (error) {
      setApiErrors(`Error: ${error.name} - ${error.response.data.message}-${error.code}`);
      setApiErrorCode(`Error: ${error.name} - ${error.code}`);
      
      console.error('Error creating Area Group:', error);
    }
    finally {
      setLoading(false);
    }
  };

  const handleCreateSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return; 
    try {
      setLoadingText('Daten werden erstellt, bitte warten...');
      setLoading(true);
      formData.rec_date = new Date();
      const recDate = formData.rec_date;
      const validDate = isValidDate(recDate) ? recDate : null;     
      formData.rec_date = validDate;
      await UserService.createAreaGroupBoard(formData);
      setDeleteState(prev => !prev);
      setShowCreateModal(false);
      
    } catch (error) {
      setApiErrors(`Error: ${error.name} - ${error.response.data.message}-${error.code}`);
      setApiErrorCode(`Error: ${error.name} - ${error.code}`);
      console.error('Error creating Area Group:', error);
     
    }
    finally {
      setLoading(false);
    }
  };

  const handleBlur = () => {
     validateForm();
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  validateForm();
  };

  const handleCloseModal = () => setShowModal(false);


  return (
    <Container>
      <h1 className="mt-5">Gebietsgruppenübersicht</h1>
                {/* Display error if it exists */}
                <ErrorModal show={showModal} handleClose={handleCloseModal} errorCode={errorCode} errorMessage={apierrors} />

      <Button variant="info" onClick={handleCreateClick} className="mr-2 mb-2">
        Erstellen
      </Button>
      {loading && (
        <div className="spinner-overlay">
         <div className="spinner-background">
          <Spinner animation="border" role="status" className="spinner-border">
            <span className="sr-only">Lade...</span>
          </Spinner>
          <div className="spinner-text">...{loadingText}</div>
          </div>
        </div>
      )}

     
      {/* Filter Input */}
      <Form.Group controlId="formBasicSearch">
        <Form.Control
          type="text"
          placeholder="Suche nach Gebietsgruppenname, ID und Datum"
          value={filterTerm}
          onChange={(e) => setFilterTerm(e.target.value)}
        />
      </Form.Group>
      {/* Table */}
      <div className="table-responsive">
      <Table striped bordered hover className="mt-4">
        <thead>
          <tr>
            {/* Sortable column headers */}
            <th onClick={() => handleSort('area_group_id')} style={{ cursor: 'pointer' }}>
              ID {sortConfig.key === 'area_group_id' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('area_group_name')} style={{ cursor: 'pointer' }}>
              Gebietsgruppenname {sortConfig.key === 'area_group_name' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('rec_date')} style={{ cursor: 'pointer' }}>
              Erstelldatum {sortConfig.key === 'rec_date' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th>Aktionen</th>
          </tr>
        </thead>
        <tbody>
          {sortedMainVOs.map((vo) => (
            <tr key={vo.area_group_id}>
              <td>{vo.area_group_id}</td>
              <td>{vo.area_group_name}</td>
              <td style={{ whiteSpace: 'nowrap' }}>{vo.rec_date}</td>
              <td>
                <ButtonGroup>
                  <Button variant="warning" onClick={() => handleEditClick(vo)} className="mr-2" title="Bearbeiten" aria-label="Bearbeiten">
                    <FaEdit />
                  </Button>
                  <Button variant="danger" onClick={(e) => handleDeleteClick(vo.area_group_id,e)} disabled={loading} title="Löschen" aria-label="Löschen">
                    {loading ? <Spinner animation="border" size="sm" /> : <FaTrash />}
                  </Button>
                </ButtonGroup>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      </div>
      <Pagination>
        <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
        <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />

        {[...Array(totalPages)].map((_, index) => (
          <Pagination.Item
            key={index}
            active={index + 1 === currentPage}
            onClick={() => handlePageChange(index + 1)}
          >
            {index + 1}
          </Pagination.Item>
        ))}

        <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
        <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
      </Pagination>
      {/* Create Modal */}
      <Modal show={showCreateModal} onHide={() => setShowCreateModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Gebietsgruppe erstellen</Modal.Title>
        </Modal.Header>
        {/* Show error message */}
        {apierrors && <Alert variant="danger">{apierrors}</Alert>}
        <Modal.Body>
          <Form onSubmit={handleCreateSubmit}>
            <Form.Group controlId="formAreaGroupName">
              <Form.Label>Gebietsgruppenname</Form.Label>
              <Form.Control
                type="text"
                placeholder="Namen der Gebietsgruppe eingeben"
                name="area_group_name"
                value={formData.area_group_name}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.area_group_name}
              />
              <Form.Control.Feedback type="invalid">
                {errors.area_group_name}
              </Form.Control.Feedback>
            </Form.Group>
             <Button variant="primary" type="submit" className="mt-3" disabled={loading}>
             {loading ? 'Wird gespeichert...' : 'Gebietsgruppe speichern'}
              
            </Button>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Edit Modal */}
      <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Gebietsgruppe bearbeiten</Modal.Title>
        </Modal.Header>
        {/* Show error message */}
        {apierrors && <Alert variant="danger">{apierrors}</Alert>}
        <Modal.Body>
          <Form onSubmit={handleEditSubmit}>
            <Form.Group controlId="formAreaGroup">
              <Form.Label>Gebietsgruppenname</Form.Label>
              <Form.Control
                type="text"
                placeholder="Namen der Gebietsgruppe eingeben"
                name="area_group_name"
                value={formData.area_group_name}
                onChange={handleChange}
                onBlur={handleBlur}
                isInvalid={!!errors.area_group_name}
              />
              <Form.Control.Feedback type="invalid">
                {errors.area_group_name}
              </Form.Control.Feedback>
            </Form.Group>
            <Button variant="primary" type="submit" className="mt-3"disabled={loading}>
            {loading ? 'Wird aktualisiert...' : 'Gebietsgruppe aktualisieren'}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default BoardAreaGroup;